import GalleryView from './GalleryViewContainer';

export default GalleryView;
